function initFeaturedSlides(root) {
  root.querySelectorAll('.featured-slides__wrapper').forEach((wrapper) => {
    const el = wrapper.querySelector('.featured-slides__swiper');
    if (!el || el.swiperInstance || typeof Swiper === 'undefined') return;

    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const autoplay = el.dataset.autoplay === 'true' && slideCount > 1;
    const autoplaySpeed = Number(el.dataset.autoplaySpeed) || 5000;
    const paginationEl = (wrapper.closest('.featured-slides') || wrapper).querySelector('.featured-slides__pagination');
    const nextEl = wrapper.querySelector('.featured-slides__next');
    const prevEl = wrapper.querySelector('.featured-slides__prev');

    // `rewind` instead of `loop`: loop mode moves slide nodes around, which would
    // re-connect the product-info / product-form custom elements on every turn.
    el.swiperInstance = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 40,
      rewind: el.dataset.rewind === 'true',
      watchOverflow: true,
      // Mouse drag on desktop, with a grab cursor. Form controls are excluded so
      // picking a variant, changing quantity or clicking buy never starts a drag.
      simulateTouch: true,
      grabCursor: true,
      threshold: 8,
      noSwipingSelector: 'input, select, textarea, label, button, .quantity, .product-form, .share-button',
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: { enabled: true },
      autoplay: autoplay ? { delay: autoplaySpeed, disableOnInteraction: true, pauseOnMouseEnter: true } : false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            type: el.dataset.paginationType || 'bullets',
          }
        : false,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
    });

    // Stop autoplay once a shopper starts interacting with a product form.
    if (autoplay) {
      el.addEventListener('focusin', () => el.swiperInstance?.autoplay.stop(), { once: true });
    }
  });
}

function destroyFeaturedSlides(root) {
  root.querySelectorAll('.featured-slides__swiper').forEach((el) => {
    if (el.swiperInstance) {
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initFeaturedSlides(document));

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initFeaturedSlides(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyFeaturedSlides(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const el = event.target.closest('.featured-slides__swiper');
    const slide = event.target.closest('.swiper-slide');
    if (!el?.swiperInstance || !slide) return;
    el.swiperInstance.autoplay?.stop();
    el.swiperInstance.slideTo(Number(slide.dataset.slideIndex) || 0);
  });
}
